import Box from '@mui/material/Box';
import { useCallback } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import { useRefreshTarget } from '../../context/RefreshContext';
import { BottomNav } from './BottomNav';
import { PullToRefresh } from './PullToRefresh';

/** BottomNav を隠すパス末尾セグメント（ツール起動中はフォーカスさせる） */
const HIDDEN_BOTTOM_NAV_SEGMENTS = ['qr', 'carry-out', 'units/qr-search'];

/**
 * モバイル用共通シェル: maxWidth 430px で中央寄せ + BottomNav。
 * 認証は親の AuthGuard が担当する前提。
 */
export const MobileShell = () => {
  const location = useLocation();
  const getRefreshHandler = useRefreshTarget();

  // 現在の画面が登録した再取得処理を実行。未登録なら全体リロードにフォールバック
  // （standalone PWA でブラウザ更新が使えない対策）。
  const handleRefresh = useCallback(() => {
    const handler = getRefreshHandler();
    return handler ? handler() : window.location.reload();
  }, [getRefreshHandler]);

  // /locations/:locationId/ 以下のサブパスで BottomNav を隠すか判定
  const sub = location.pathname.replace(/^\/locations\/[^/]+/, '');
  const hideBottomNav = HIDDEN_BOTTOM_NAV_SEGMENTS.some(
    (seg) => sub === `/${seg}` || sub.startsWith(`/${seg}/`),
  );

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        backgroundColor: (theme) => theme.palette.grey[100],
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 430,
          minHeight: '100dvh',
          // ページ全体を grey.100 で統一（コンテンツが短くても下端まで色が続く）
          backgroundColor: (theme) => theme.palette.grey[100],
          position: 'relative',
        }}
      >
        {/* 画面コンテンツのみ pull-to-refresh で動かす。BottomNav は外（兄弟）に置き、
            transform の包含ブロックに入れない＝固定のまま壊さない。 */}
        <PullToRefresh onRefresh={handleRefresh}>
          <Outlet />
        </PullToRefresh>
        {!hideBottomNav && <BottomNav />}
      </Box>
      {/* 画面遷移時はトップにスクロール (戻る時は履歴位置を復元、5/28 MTG) */}
      <ScrollRestoration getKey={(location) => location.pathname} />
    </Box>
  );
};
